import { Component, Input, OnInit } from '@angular/core';
import { ControlBase } from '../../shared/models/control-base';
import { FormControl, FormGroup } from '@angular/forms';
import { map, startWith } from 'rxjs';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.css']
})
export class FormControlComponent implements OnInit {

  @Input() control!: ControlBase<string>;
  @Input() form!: FormGroup
  options: any;
  filterControl = new FormControl();
  filteredOptions: any[] = [];
  originData: any[] = []

  get isValid() {
    return this.form.controls[this.control.key].valid;
  }

  constructor() {
  }
  ngOnInit(): void {
    this.control.optionsObject.subscribe(res => {
      this.filteredOptions = res
      this.originData = [...this.filteredOptions]
    })

    this.filterControl.valueChanges
      .pipe(
        startWith(''),
        map((value: string | any) => {
          const filterValue = typeof value === 'string' ? value : value?.partnerName || '';
          return this._filter(filterValue);
        })
      )
      .subscribe((filtered) => (this.filteredOptions = filtered));
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.originData.filter((opt) =>
      opt.partnerName.toLowerCase().includes(filterValue)
    );
  }

  displayFn(option: any): string {
    return option?.partnerName || '';
  }

  compareFunction(a: any, b: any) {
    return (+a.id === +b.id && a.description === b.description);
  }

  preventSpace(event: KeyboardEvent) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

}
